import { PortalDsBadge } from 'src/components/portal-design-system';
import type { Client } from '../../types/client.types';
import { isClientStudioMigrated } from '../../utils/client-display.utils';

interface StudioMigratedBadgeProps {
  client: Pick<Client, 'studio_migrated_at' | 'studio_ready'>;
}

export function StudioMigratedBadge({ client }: StudioMigratedBadgeProps) {
  if (!isClientStudioMigrated(client)) {
    return null;
  }

  return (
    <PortalDsBadge
      pill
      variant="green"
    >
      Migrated
    </PortalDsBadge>
  );
}
